import { MINIMUM_QUERY_LENGTH, SEARCH_RESULTS_PER_PAGE } from '@constants';
import useStore from '@utils/useStore';
import singletonRouter from 'next/router';
import PropTypes from 'prop-types';
import { Configure, InstantSearch } from 'react-instantsearch';
import { createInstantSearchRouterNext } from 'react-instantsearch-router-nextjs';

function SearchWrapper({
  children,
  hitsPerPage = SEARCH_RESULTS_PER_PAGE,
  withRouting,
}) {
  const {
    store: { searchClient, searchIndex },
  } = useStore();

  return (
    <InstantSearch
      searchClient={{
        ...searchClient,
        search(requests) {
          // Prevent empty searches or searches with less than 3 characters
          if (
            requests.every(
              ({ params }) =>
                !params.query || params.query.length < MINIMUM_QUERY_LENGTH
            )
          ) {
            return Promise.resolve({
              results: requests.map(() => ({
                hits: [],
                nbHits: 0,
                nbPages: 0,
                page: 0,
                processingTimeMS: 0,
                hitsPerPage: 0,
                exhaustiveNbHits: false,
                query: '',
                params: '',
              })),
            });
          }

          return searchClient.search(requests);
        },
      }}
      indexName={searchIndex}
      routing={
        withRouting && {
          router: createInstantSearchRouterNext({
            singletonRouter,
            routerOptions: {
              cleanUrlOnDispose: false,
            },
          }),
        }
      }
    >
      <Configure hitsPerPage={hitsPerPage} />
      {children}
    </InstantSearch>
  );
}

SearchWrapper.propTypes = {
  children: PropTypes.node,
  hitsPerPage: PropTypes.number,
  withRouting: PropTypes.bool,
};

export default SearchWrapper;
